import Component from '../abstracts/Component';

export default class AddToWishlistComponent extends Component {
  get SELECTORS() {
    return {
      addToWish: '.js-wishlist-cta',
      notAdded: '.js-addtowish',
      added: '.js-added-wish',
      iconWishList: '#iconWishlist',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      on: 'js-added-wish',
      off: 'js-addtowish',
      added: 'icon-wishlist-on',
      notAdded: 'icon-wishlist'
    };
  }

  constructor() {
    super();

    this.notAdded = $(this.SELECTORS.notAdded);
    this.added = $(this.SELECTORS.added);
    this.addToWish = $(this.SELECTORS.addToWish);
    this.iconWishList = $(this.SELECTORS.iconWishList);
  }

  bindEvents() {
    let ctx = this;

    //click on wishlist
    $('body').on('click.addtowish', ctx.SELECTORS.notAdded, function (e) {
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtowish, $this);
      $this.data('tracking-action', '');
    });

    $('body').on('click.removefromwish', ctx.SELECTORS.added, function (e) {
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, $this);
      $this.data('tracking-action', 'wishlistAdd');
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged,({event, payload}) => {
        let code = $(payload.button).data('code');
        this.log(code);
        this.addToWish.data('code', code);
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, (e) => {
      let code = $(e.payload).data('code');
      let $cta = $(e.payload);
      // $(this.SELECTORS.iconWishList+"-"+code).removeClass(this.CLASSES.notAdded).addClass(this.CLASSES.added);
      $cta.removeClass(this.CLASSES.off).addClass(this.CLASSES.on);
      $cta.data('href', `/action/miniwishlist/remove?productCode=${code}`);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      let code = $(e.payload).data('code');
      let $cta = '';
      if ($(e.payload).hasClass('js-wishlist-cta')) {
        $cta = $(e.payload);
      } else {
        $cta = $(`.js-wishlist-cta[data-code=${code}]`);
      }
      // $(this.SELECTORS.iconWishList+"-"+code).removeClass(this.CLASSES.added).addClass(this.CLASSES.notAdded);
      $cta.removeClass(this.CLASSES.on).addClass(this.CLASSES.off);
      $cta.data('href', `/action/ajax/wishlist-add`);
    });

    // modal error exceed quantity afterOpen
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, ({event,payload}) => {
      // find the wishlist button in the modal
      let modalBtn = payload.rootEl.querySelector(ctx.SELECTORS.addToWish);
      // check
      if (modalBtn == null) return;
      // vex instance
      let vexx = payload;
      // update size
      modalBtn.setAttribute('data-code',payload.conf.size);
      // bind click to add to wishlist
      modalBtn.addEventListener('click',function(e) {
        e.preventDefault();
        e.stopPropagation();
        // go add to wish
        let $this = $(this);
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtowish, $this);
        // close modal
        vexx.close();
      });
    });
  }

  isAddedToWishlist() {
    //check on load to unset tracking action, avoids tracking call on remove-from-wishlist
    const icons = document.querySelectorAll(".js-added-wish");
    icons.forEach((icon) => {
      $(icon).data('tracking-action', '');
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    window.addEventListener('load', (event) => {
      this.isAddedToWishlist();
    });
  }
}
